import React from 'react';
import styles from './styles.module.css'
import LinearProgress from "@material-ui/core/LinearProgress";
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/styles";


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 3,
  },
  colorPrimary: {
    backgroundColor: "#ebebeb",
  },
  bar: {
    borderRadius: 3,
    backgroundColor: '#00b74a',
  },
}))(LinearProgress);


const useStyles = makeStyles((theme) => ({
  snackbar: {
    bottom: "60px",
    borderRadius: ".25rem",
  },

}));

const SavingSnackbar = ({ status, updateSavingStatus, savingErrorMessage }) => {
  const handleClose = () => {
    updateSavingStatus({ status: '', message: '' })
  };

  const open = !!status;

  const classes = useStyles();
  if (!status) {
    return null
  }
  return (
    <>
      <div className={`${styles.snackbarOverlay} ${open || status !== 'success' ? styles.open : ''}`}></div>
      {status === "success" &&
        <Snackbar open={open} className={classes.snackbar} autoHideDuration={1250}
                  onClose={handleClose}>
          <Alert severity="success">
            Сохранено
          </Alert>
        </Snackbar>}
      {status === "error" &&
        <Snackbar open={open} className={classes.snackbar} autoHideDuration={2000}
                  onClose={handleClose}>
          <Alert severity="error">
            {savingErrorMessage ? savingErrorMessage : "Ошибка"}
          </Alert>
        </Snackbar>}
      {status === "loading" && <div className={`${styles.snackbarWrp}`}>
        <div className={`${styles.snackbarText}`}>Сохраняем...</div>
        <BorderLinearProgress className="w-100"/>
      </div>
      }
    </>

  )


}


export default SavingSnackbar
